<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",

  mounted() {
    /* 区分关闭和刷新，关闭退出登录 start*/
    window.onload = function () {
      if (!window.sessionStorage["ISlogin"]) {
        // removeToken()
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        location.reload(); // 不能省，强制跳到登陆页
      } else {
        window.sessionStorage.removeItem("ISlogin");
      }
    };
    window.onunload = function () {
      window.sessionStorage["ISlogin"] = true;
    };
    window.onbeforeunload = function () {
      window.sessionStorage["ISlogin"] = true;
    };
  },
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0px;
  margin: 0px;
  /* background-color: #f2f2f2; */
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  widows: 100%;
  height: 100%;
}

a {
  text-decoration: none;
}

ul {
  list-style: none outside none;
}

.position_relative {
  position: relative;
}

.position_absolute {
  position: absolute;
}

.position_fixed {
  position: fixed;
}

/* 小手指标 */
.cursor_pointer {
  cursor: pointer;
}

.flex {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

/*从左到右*/

.flexLeft {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -moz-box-orient: horizontal;
  -moz-box-direction: normal;
  flex-direction: row;
  -webkit-flex-direction: row;
}

/*从右到左*/

.flexRight {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -moz-box-orient: horizontal;
  -moz-box-direction: reverse;
  flex-direction: row-reverse;
  -webkit-flex-direction: row-reverse;
}

/*从上到下*/

.flexTop {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -moz-box-orient: vertical;
  -moz-box-direction: normal;
  flex-direction: column;
  -webkit-flex-direction: column;
}

/*从下到上*/

.flexBottom {
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
  -moz-box-orient: vertical;
  -moz-box-direction: reverse;
  flex-direction: column;
  -webkit-flex-direction: column;
}

/*flexWrap换行*/

.flexWrap {
  -webkit-flex-wrap: wrap;
  -webkit-box-lines: multiple;
  -moz-flex-wrap: wrap;
  flex-wrap: wrap;
}

/*flexNowarp不换行*/

.flexNowrap {
  -webkit-flex-wrap: nowrap;
  -webkit-box-lines: single;
  -moz-flex-wrap: nowarp;
  flex-wrap: nowrap;
}

/*justify-content 居中*/

.justifyCenter {
  -webkit-justify-content: center;
  justify-content: center;
  -moz-box-pack: center;
  /* -webkit--moz-box-pack: center; */
  -webkit-box-pack: justify;
  -moz-box-pack: justify;
  -ms-flex-pack: justify;
}

/*justify-content 居左/上*/

.justifyLeft {
  -webkit-justify-content: flex-start;
  -moz-box-pack: start;
  /* -webkit--moz-box-pack: start; */
  box-pack: start;
  justify-content: flex-start;
}

/*justify-content 居右/下*/

.justifyRight {
  -webkit-justify-content: flex-end;
  -moz-box-pack: end;
  /* -webkit--moz-box-pack: end; */
  box-pack: end;
  justify-content: flex-end;
}

/*justify-content space-round*/

.justifyRound {
  -webkit-justify-content: space-around;
  -moz-box-pack: center;
  /* -webkit--moz-box-pack: center; */
  box-pack: center;
  justify-content: space-around;
}

/*justify-content space-between*/

.justifyBetween {
  -webkit-justify-content: space-between;
  -moz-box-pack: justify;
  /* -webkit--moz-box-pack: justify; */
  box-pack: justify;
  justify-content: space-between;
}

/*align-items 居中*/

.alignCenter {
  -webkit-box-align: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  box-align: center;
  align-items: center;
}

/*align-items 居上*/

.alignStart {
  -webkit-box-align: start;
  -moz-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  box-align: start;
  align-items: flex-start;
}

/*align-items 居下*/

.alignEnd {
  -webkit-box-align: end;
  -moz-box-align: end;
  -ms-flex-align: end;
  -webkit-align-items: flex-end;
  box-align: end;
  align-items: flex-end;
}

/*align-items 基线对齐*/

.alignBaseline {
  -webkit-box-align: baseline;
  -moz-box-align: baseline;
  -ms-flex-align: baseline;
  -webkit-align-items: baseline;
  box-align: baseline;
  align-items: baseline;
}

/*align-items 拉伸子元素充满*/

.alignStretch {
  -webkit-box-align: stretch;
  -moz-box-align: stretch;
  -ms-flex-align: stretch;
  -webkit-align-items: stretch;
  box-align: stretch;
  align-items: stretch;
}

.flex1 {
  -webkit-flex: 1;
  -ms-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  flex: 1;
}

.vh_100 {
  height: 100vh;
}

.w_100 {
  width: 100%;
}

.w_90 {
  width: 90%;
}

.w_80 {
  width: 80%;
}

.w_70 {
  width: 70%;
}

.w_60 {
  width: 60%;
}

.w_50 {
  width: 50%;
}

.w_40 {
  width: 40%;
}

.w_30 {
  width: 30%;
}

.w_25 {
  width: 25%;
}
.w_20 {
  width: 20%;
}

.marginA {
  margin: auto;
}

.textCenter {
  text-align: center;
}

.textOverflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.font_size12 {
  font-size: 12px;
}

.font_size14 {
  font-size: 14px;
}

.font_size16 {
  font-size: 16px;
}

.font_size18 {
  font-size: 18px;
}

.font_size24 {
  font-size: 24px;
}

.font_size30 {
  font-size: 30px;
}

.font_bold {
  font-weight: bold;
}
.color_409EFF {
  color: #409eff;
}
.color_C0C4CC {
  color: #c0c4cc;
}
.color_DA0B00 {
  color: #da0b00 !important;
}
.color_w {
  color: white;
}

.p10 {
  padding: 10px;
  box-sizing: border-box;
}

.p20 {
  padding: 20px;
  box-sizing: border-box;
}

.p24 {
  padding: 24px;
  box-sizing: border-box;
}

.p30 {
  padding: 30px;
  box-sizing: border-box;
}

.p32 {
  padding: 32px;
  box-sizing: border-box;
}

.p_t_0 {
  padding-top: 0 !important;
  box-sizing: border-box;
}

.p_t_8 {
  padding-top: 8px;
  box-sizing: border-box;
}

.p_t_5 {
  padding-top: 5px;
  box-sizing: border-box;
}

.p_t_10 {
  padding-top: 10px;
  box-sizing: border-box;
}

.p_t_15 {
  padding-top: 15px;
  box-sizing: border-box;
}

.p_t_20 {
  padding-top: 20px;
  box-sizing: border-box;
}

.p_t_21 {
  padding-top: 21px !important;
  box-sizing: border-box;
}

.p_t_24 {
  padding-top: 24px !important;
  box-sizing: border-box;
}

.p_t_28 {
  padding-top: 28px !important;
  box-sizing: border-box;
}

.p_t_30 {
  padding-top: 30px;
  box-sizing: border-box;
}

.p_t_31 {
  padding-top: 31px;
  box-sizing: border-box;
}

.p_t_33 {
  padding-top: 33px;
  box-sizing: border-box;
}

.p_t_40 {
  padding-top: 40px;
}

.p_t_42 {
  padding-top: 42px;
}

.p_t_50 {
  padding-top: 50px;
  box-sizing: border-box;
}

.p_t_52 {
  padding-top: 52px;
  box-sizing: border-box;
}

.p_t_60 {
  padding-top: 60px;
  box-sizing: border-box;
}

.p_tb_24 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
  box-sizing: border-box;
}

.p_tb_27 {
  padding-top: 27px !important;
  padding-bottom: 27px !important;
  box-sizing: border-box;
}

.p_tb_28 {
  padding-top: 28px !important;
  padding-bottom: 28px !important;
  box-sizing: border-box;
}

.p_b_0 {
  padding-bottom: 0px !important;
  box-sizing: border-box;
}

.p_b_10 {
  padding-bottom: 10px;
  box-sizing: border-box;
}

.p_b_8 {
  padding-bottom: 8px !important;
  box-sizing: border-box;
}

.p_b_15 {
  padding-bottom: 15px;
  box-sizing: border-box;
}

.p_b_16 {
  padding-bottom: 16px;
  box-sizing: border-box;
}

.p_b_20 {
  padding-bottom: 20px;
  box-sizing: border-box;
}

.p_b_24 {
  padding-bottom: 24px !important;
  box-sizing: border-box;
}

.p_b_28 {
  padding-bottom: 28px !important;
  box-sizing: border-box;
}

.p_b_30 {
  padding-bottom: 30px;
  box-sizing: border-box;
}

.p_b_31 {
  padding-bottom: 31px !important;
}

.p_b_31-25 {
  padding-bottom: 31.25px;
  box-sizing: border-box;
}

.p_b_32 {
  padding-bottom: 32px !important;
  box-sizing: border-box;
}

.p_b_40 {
  padding-bottom: 40px;
  box-sizing: border-box;
}

.p_b_42 {
  padding-bottom: 42px;
  box-sizing: border-box;
}

.p_b_50 {
  padding-bottom: 50px;
  box-sizing: border-box;
}

.p_b_80 {
  padding-bottom: 80px;
  box-sizing: border-box;
}

.p_b_100 {
  padding-bottom: 100px;
  box-sizing: border-box;
}

.p_b_120 {
  padding-bottom: 120px;
  box-sizing: border-box;
}

.p_b_136 {
  padding-bottom: 136px !important;
  box-sizing: border-box;
}

.p_b_160 {
  padding-bottom: 160px !important;
  box-sizing: border-box;
}

.p_b_safrty {
  padding-bottom: env(safe-area-inset-bottom) !important;
  box-sizing: border-box;
}

.p_tb_5 {
  padding: 5px 0;
  box-sizing: border-box;
}

.p_tb_10 {
  padding: 10px 0;
  box-sizing: border-box;
}

.p_tb_12 {
  padding: 12px 0;
  box-sizing: border-box;
}

.p_tb_20 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
  box-sizing: border-box;
}

.p_tb_30 {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
  box-sizing: border-box;
}

.p_tb_31 {
  padding-top: 31px !important;
  padding-bottom: 31px !important;
  box-sizing: border-box;
}

.p_tb_33 {
  padding-top: 33px !important;
  padding-bottom: 33px !important;
  box-sizing: border-box;
}

.p_tb_36 {
  padding-top: 36px !important;
  padding-bottom: 36px !important;
  box-sizing: border-box;
}

.p_tb_42 {
  padding-top: 42px !important;
  padding-bottom: 42px !important;
  box-sizing: border-box;
}

.p_l_10 {
  padding-left: 10px;
  box-sizing: border-box;
}

.p_l_20 {
  padding-left: 20px;
  box-sizing: border-box;
}

.p_l_24 {
  padding-left: 24px;
  box-sizing: border-box;
}

.p_l_30 {
  padding-left: 30px;
  box-sizing: border-box;
}

.p_l_32 {
  padding-left: 32px;
  box-sizing: border-box;
}

.p_l_50 {
  padding-left: 50px;
  box-sizing: border-box;
}

.p_r_10 {
  padding-right: 10px;
  box-sizing: border-box;
}

.p_r_14 {
  padding-right: 14px;
  box-sizing: border-box;
}

.p_r_20 {
  padding-right: 20px;
  box-sizing: border-box;
}

.p_r_24 {
  padding-right: 24px;
  box-sizing: border-box;
}

.p_r_30 {
  padding-right: 30px;
  box-sizing: border-box;
}

.p_r_32 {
  padding-right: 32px;
  box-sizing: border-box;
}

.p_r_42 {
  padding-right: 42px !important;
  box-sizing: border-box;
}

.p_lr_0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
  box-sizing: border-box;
}

.p_lr_10 {
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
}

.p_lr_12 {
  padding-left: 12px;
  padding-right: 12px;
  box-sizing: border-box;
}

.p_lr_13 {
  padding-left: 13px;
  padding-right: 13px;
  box-sizing: border-box;
}

.p_lr_15 {
  padding-left: 15px !important;
  padding-right: 15px !important;
  box-sizing: border-box;
}

.p_lr_20 {
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
}

.p_lr_21 {
  padding-left: 21px;
  padding-right: 21px;
  box-sizing: border-box;
}

.p_lr_25 {
  padding-left: 25px;
  padding-right: 25px;
  box-sizing: border-box;
}

.p_lr_30 {
  padding: 0 30px;
  box-sizing: border-box;
}

.p_lr_32 {
  padding-left: 32px !important;
  padding-right: 32px !important;
  box-sizing: border-box;
}

.p_lr_33 {
  padding-left: 33px !important;
  padding-right: 33px !important;
  box-sizing: border-box;
}

.p_lr_46 {
  padding-left: 46px !important;
  padding-right: 46px !important;
  box-sizing: border-box;
}

.p_lr_54 {
  padding-left: 46px !important;
  padding-right: 46px !important;
  box-sizing: border-box;
}

/* margin */
.m_r_50 {
  margin-right: 50px;
}

.m5 {
  margin: 5px;
}

.m10 {
  margin: 10px;
}

.m20 {
  margin: 20px;
}

.m30 {
  margin: 30px;
}

.m_t_0 {
  margin-top: 0 !important;
}

.m_t_4 {
  margin-top: 4px !important;
}

.m_t_5 {
  margin-top: 5px;
}

.m_t_6 {
  margin-top: 6px !important;
}

.m_t_8 {
  margin-top: 8px;
}

.m_t_10 {
  margin-top: 10px;
}

.m_t_12 {
  margin-top: 12px;
}

.m_t_15 {
  margin-top: 15px;
}

.m_t_16 {
  margin-top: 16px;
}

.m_t_20 {
  margin-top: 20px;
}

.m_t_21 {
  margin-top: 21px;
}

.m_t_24 {
  margin-top: 24px;
}

.m_t_25 {
  margin-top: 25px;
}

.m_t_30 {
  margin-top: 30px;
}

.m_t_31 {
  margin-top: 31px;
}

.m_t_35 {
  margin-top: 35px;
}

.m_t_40 {
  margin-top: 40px;
}

.m_t_50 {
  margin-top: 50px !important;
}

.m_t_51 {
  margin-top: 51px !important;
}

.m_t_52 {
  margin-top: 52px !important;
}

.m_t_70 {
  margin-top: 70px;
}

.m_t_100 {
  margin-top: 100px;
}

.m_l_0 {
  margin-left: 0 !important;
}

.m_l_5 {
  margin-left: 5px;
}

.m_l_10 {
  margin-left: 10px;
}

.m_l_15 {
  margin-left: 15px;
}

.m_l_20 {
  margin-left: 20px;
}

.m_l_21 {
  margin-left: 21px;
}

.m_l_24 {
  margin-left: 24px;
}

.m_l_30 {
  margin-left: 30px;
}

.m_l_32 {
  margin-left: 32px;
}

.m_l_50 {
  margin-left: 50px;
}

.m_l_63 {
  margin-left: 63px;
}

.m_l_100 {
  margin-left: 100px;
}

.m_l_130 {
  margin-left: 130px;
}

.m_r_130 {
  margin-right: 130px;
}

.m_b_0 {
  margin-bottom: 0 !important;
}

.m_b_2 {
  margin-bottom: 2px !important;
}

.m_b_4 {
  margin-bottom: 4px !important;
}

.m_b_5 {
  margin-bottom: 5px;
}

.m_b_8 {
  margin-bottom: 8px;
}

.m_b_10 {
  margin-bottom: 10px;
}

.m_b_12 {
  margin-bottom: 12px;
}

.m_b_18 {
  margin-bottom: 18px !important;
}

.m_b_20 {
  margin-bottom: 20px;
}

.m_b_21 {
  margin-bottom: 21px;
}

.m_b_24 {
  margin-bottom: 24px;
}

.m_b_28 {
  margin-bottom: 28px;
}

.m_b_30 {
  margin-bottom: 30px;
}

.m_b_31 {
  margin-bottom: 31px;
}

.m_b_31-25 {
  margin-bottom: 31.25px;
}

.m_b_32 {
  margin-bottom: 32px;
}

.m_b_40 {
  margin-bottom: 40px;
}

.m_b_41 {
  margin-bottom: 41px;
}

.m_b_42 {
  margin-bottom: 42px;
}

.m_b_45 {
  margin-bottom: 45px !important;
}

.m_b_50 {
  margin-bottom: 50px;
}

.m_b_52 {
  margin-bottom: 52px;
}

.m_b_60 {
  margin-bottom: 60px;
}

.m_tb_5 {
  margin: 5px 0;
}

.m_tb_10 {
  margin: 10px 0;
}

.m_tb_20 {
  margin: 20px 0;
}

.m_tb_30 {
  margin: 30px 0;
}

.m_r_0 {
  margin-right: 0 !important;
}

.m_r_5 {
  margin-right: 5px;
}

.m_r_10 {
  margin-right: 10px !important;
}

.m_r_15 {
  margin-right: 15px;
}

.m_r_20 {
  margin-right: 20px !important;
}

.m_r_21 {
  margin-right: 21px !important;
}

.m_r_24 {
  margin-right: 24px !important;
}

.m_r_30 {
  margin-right: 30px;
}

.m_r_31 {
  margin-right: 31px;
}

.m_r_30 {
  margin-right: 30px;
}

.m_r_33 {
  margin-right: 33px;
}

.m_r_40 {
  margin-right: 40px;
}

.m_r_42 {
  margin-right: 42px;
}

.m_r_31 {
  margin-right: 31px;
}

.m_r_32 {
  margin-right: 32px;
}

.m_r_100 {
  margin-right: 100px;
}

.m_lr_5 {
  margin: 0 5px;
}

.m_lr_10 {
  margin: 0 10px;
}

.m_lr_20 {
  margin: 0 20px;
}

.m_lr_30 {
  margin: 0 30px;
}

.m_lr_40 {
  margin: 0 40px;
}

.m_lr_50 {
  margin: 0 50px;
}

.m_lr_50 {
  margin: 0 50px;
}

.m_lr_5 {
  margin: 0 5px;
}

.m_lr_10 {
  margin: 0 10px;
}

.m_lr_20 {
  margin: 0 20px;
}

.m_lr_30 {
  margin: 0 30px;
}
/* 整个滚动条 */
::-webkit-scrollbar {
  width: 10px; /* 竖向滚动条宽度 */
  height: 10px; /* 横向滚动条高度（可选） */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}

/* 滚动条滑块（可拖动部分） */
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 8px;
  border: 2px solid #f1f1f1; /* 可选：滑块边缘留白 */
}

/* 滑块悬停状态 */
::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>



// WEBPACK FOOTER //
// src/App.vue